/**
 * HeaderCarousel - slideshow pro header obrázky
 * Přechod zprava doleva, auto-play, object-fit: cover
 */
export function initialize(selector, options = {}) {
    const carousel = document.querySelector(selector);
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.header-carousel-slide');
    if (slides.length < 2) return;

    const interval = options.interval || 5000;
    const transitionDuration = options.transitionDuration || 800;

    let currentIndex = 0;
    let isAnimating = false;

    // Nastavení počátečního stavu
    slides.forEach((slide, i) => {
        slide.style.transition = `transform ${transitionDuration}ms ease`;
        if (i === 0) {
            slide.classList.add('is-active');
        }
    });

    function goToNext() {
        if (isAnimating) return;
        isAnimating = true;

        const nextIndex = (currentIndex + 1) % slides.length;
        const currentSlide = slides[currentIndex];
        const nextSlide = slides[nextIndex];

        // Připravit next slide vpravo
        nextSlide.style.transition = 'none';
        nextSlide.classList.add('is-next');

        // Force reflow
        nextSlide.offsetHeight;

        // Spustit animaci
        nextSlide.style.transition = `transform ${transitionDuration}ms ease`;
        currentSlide.classList.add('is-leaving');
        nextSlide.classList.remove('is-next');
        nextSlide.classList.add('is-active');

        setTimeout(() => {
            currentSlide.classList.remove('is-active', 'is-leaving');
            currentIndex = nextIndex;
            isAnimating = false;
        }, transitionDuration);
    }

    // Auto-play
    let autoPlay = setInterval(goToNext, interval);

    // Pauza při hoveru
    carousel.addEventListener('mouseenter', () => clearInterval(autoPlay));
    carousel.addEventListener('mouseleave', () => {
        autoPlay = setInterval(goToNext, interval);
    });
}
